module.exports = __webpack_public_path__ + "img/image2.98483517.png";